import * as z from "zod";

export const exchangeProfileSchema = z
    .object({
        source: z.string(),
        title: z.string(),
    })
    .optional();

export type ExchangeProfileType =
    | z.infer<typeof exchangeProfileSchema>
    | undefined;
